(() => {
  // Remove data left by the retired favorites feature without reading or recreating it.
  try { window.localStorage.removeItem('dabov:wishlist:v1'); } catch (_error) {}

  const checkboxSelector = '[data-dabov-legal-checkbox]';

  const updateTimestamp = (checkbox) => {
    const wrapper = checkbox.closest('[data-dabov-legal-acknowledgement]');
    const timestamp = wrapper?.querySelector('[data-dabov-legal-timestamp]');
    if (!timestamp) return;

    timestamp.disabled = !checkbox.checked;
    timestamp.value = checkbox.checked ? new Date().toISOString() : '';
  };

  const initializeCheckboxes = (root = document) => {
    root.querySelectorAll(checkboxSelector).forEach(updateTimestamp);
  };

  const resetCheckboxes = () => {
    document.querySelectorAll(checkboxSelector).forEach((checkbox) => {
      checkbox.checked = false;
      updateTimestamp(checkbox);
    });
  };

  document.addEventListener('change', (event) => {
    if (event.target.matches(checkboxSelector)) updateTimestamp(event.target);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, resetCheckboxes);
  }

  // Consent collection is owned by Shopify's native banner, configured in Customer privacy.
  let openingPreferences = false;
  const openCookiePreferences = async (trigger) => {
    if (openingPreferences) return;
    openingPreferences = true;
    trigger?.setAttribute('aria-busy', 'true');
    try {
      for (let attempt = 0; attempt < 40; attempt += 1) {
        if (typeof globalThis.privacyBanner?.showPreferences === 'function') {
          await globalThis.privacyBanner.showPreferences();
          const status = document.querySelector('[data-dabov-privacy-status]');
          if (status) status.textContent = '';
          return;
        }
        await new Promise((resolve) => window.setTimeout(resolve, 50));
      }
      throw new Error('Shopify privacy banner is unavailable');
    } catch (_error) {
      let status = document.querySelector('[data-dabov-privacy-status]');
      if (!status) {
        status = document.createElement('p');
        status.dataset.dabovPrivacyStatus = '';
        status.setAttribute('role', 'status');
        status.style.fontSize = '1.3rem';
        trigger?.parentElement?.append(status);
      }
      status.textContent = 'Çerez tercihleri yüklenemedi. Lütfen sayfayı yenileyip tekrar deneyin.';
    } finally {
      openingPreferences = false;
      trigger?.removeAttribute('aria-busy');
    }
  };
  globalThis.dabovOpenCookiePreferences = openCookiePreferences;

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest?.('[data-dabov-cookie-preferences]');
    if (!trigger) return;
    event.preventDefault();
    openCookiePreferences(trigger);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeCheckboxes(), { once: true });
  } else {
    initializeCheckboxes();
  }
  document.addEventListener('shopify:section:load', (event) => initializeCheckboxes(event.target));
})();
